// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4065":"css/admin-app.7067","7321":"css/app.7067"}[chunkId] + ".css";
};